import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { RoleDetailResponse } from '../../role-management/models/role-management-api.model';
import { PolicyDetailResponse } from '../models/policy-api.model';
import { PortalUserDetail, PortalUserUpdatePayload } from '../models/user-management-api';

export const UserManagementActions = createActionGroup({
  source: 'User Management',
  events: {
    'Load User': props<{ userId: string; includeDetails?: boolean }>(),
    'Load User Success': props<{
      user: PortalUserDetail;
      roles: Record<string, RoleDetailResponse>;
      policies: Record<string, PolicyDetailResponse>;
    }>(),
    'Load User Failure': props<{ error: string }>(),
    'Load Policy': props<{ policyId: string }>(),
    'Load Policy Success': props<{ policy: PolicyDetailResponse }>(),
    'Load Policy Failure': props<{ error: string }>(),
    'Update User': props<{
      userId: string;
      payload: PortalUserUpdatePayload;
    }>(),
    'Update User Success': props<{
      user: PortalUserDetail;
      roles: Record<string, RoleDetailResponse>;
      policies: Record<string, PolicyDetailResponse>;
      message: string;
    }>(),
    'Update User Failure': props<{ error: string }>(),
    'Set User Status': props<{
      userId: string;
      active: boolean;
      deactivationReason?: string;
    }>(),
    'Set User Status Success': props<{
      active: boolean;
      message: string;
    }>(),
    'Set User Status Failure': props<{ error: string }>(),
    'Clear Selected User': emptyProps(),
    'Clear Feedback': emptyProps(),
  },
});
